import { OpmWaterfallConditionIrrHurdleDetailsPeriodDto } from '@app/shared/models/contracts/opm-calculation-results-dto';
import { Pwerm2CalculationWaterfallCaseInstrumentTrancheConditionSponsorIrrCorkscrewPeriodDto } from '@app/shared/models/contracts/pwerm2-calculation-results-dto';

const getOneYearBeforeDate = (date: string): Date => {
  const exit = new Date(date);
  const cutoff = new Date(exit);
  cutoff.setFullYear(exit.getFullYear() - 1);
  return cutoff;
};

export const hasHistoricPeriods = (
  periods:
    | Pwerm2CalculationWaterfallCaseInstrumentTrancheConditionSponsorIrrCorkscrewPeriodDto[]
    | OpmWaterfallConditionIrrHurdleDetailsPeriodDto[],
  exitDate: string
): boolean => {
  if (!Array.isArray(periods)) {
    return false;
  }
  const cutoff = getOneYearBeforeDate(exitDate);
  return periods.some((p) => new Date(p.periodStart) <= cutoff);
};

export const filterPeriodsForYear = (
  periods:
    | Pwerm2CalculationWaterfallCaseInstrumentTrancheConditionSponsorIrrCorkscrewPeriodDto[]
    | OpmWaterfallConditionIrrHurdleDetailsPeriodDto[],
  exitDate: string,
  processingHistoricData: boolean
) => {
  if (!Array.isArray(periods)) {
    return [];
  }
  const cutoff = getOneYearBeforeDate(exitDate);
  return processingHistoricData
    ? periods.filter((p) => new Date(p.periodStart) <= cutoff)
    : periods.filter((p) => new Date(p.periodStart) > cutoff);
};
